<p-toast></p-toast>
<p-messages key="view-invoice-result"></p-messages>
<div class="h-full w-full">
    <div class="grid flex justify-content-center">
        <div class="col-8">
            <div class="grid pt-5">
                <div class="col-4">
                    <div class="field">
                        <label for="suite" class="label-required block mb-2">Invoice Number</label>
                        <input id="suite" type="text" pInputText [(ngModel)]="invoiceNumber" class="w-full"
                            [disabled]="invoiceInProgress">
                    </div>
                </div>
                <div class="col-4">
                    <div class="field">
                        <label class="block mb-2">&nbsp;</label>
                        <p-button
                            label="View" icon="pi pi-arrow-right" iconPos="right"
                            [disabled]="!invoiceNumber"
                            [loading]="invoiceInProgress"
                            (onClick)="viewInvoice()"
                            class="w-full">
                        </p-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>